import { render } from "./SliderWrapper.vue?vue&type=template&id=1deb27cc&scoped=true"
import script from "./SliderWrapper.vue?vue&type=script&lang=js"
export * from "./SliderWrapper.vue?vue&type=script&lang=js"

import "./SliderWrapper.vue?vue&type=style&index=0&id=1deb27cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1deb27cc"]])

export default __exports__